import { useUserContext } from "@magento/peregrine/lib/context/user";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import { bool, shape, string } from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useSocialLoginContext } from "../../context";
import SocialButtons from "../SocialButtons";
import defaultClasses from "./socialAuthentication.css";
const SocialAuthentication = props => {
  const {
    mode,
    isPopup,
    showCreateAccount,
    textSeparator,
    bottomSeparator,
    onClick,
    children
  } = props;
  const {
    buttons,
    isEnabled,
    buttonPosition,
    enabledModes
  } = useSocialLoginContext();
  const [{
    isSignedIn
  }] = useUserContext();
  if (!isEnabled || !enabledModes.includes(mode) || isSignedIn) {
    return null;
  }
  const classes = mergeClasses(defaultClasses, props.classes);
  const rootClass = isPopup ? "".concat(classes.root_popup, " ").concat(classes[buttonPosition]) : "".concat(classes.root, " ").concat(classes[mode]);
  return /*#__PURE__*/React.createElement("div", {
    className: rootClass
  }, /*#__PURE__*/React.createElement(SocialButtons, {
    buttons: buttons,
    showCreateAccount: showCreateAccount,
    mode: mode,
    onClick: onClick,
    hasBottomSeparator: !!bottomSeparator,
    disclaimer: children
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.separatorBottom, " ").concat(children ? classes.withDisclaimer : "")
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.separatorIcon
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "social.login.separator"
  }))));
};
SocialAuthentication.propTypes = {
  classes: shape({
    root: string
  }),
  mode: string,
  isPopup: bool
};
export default SocialAuthentication;